export const connectAmoyNetworkMEW = [
  {
    title: "Cómo conectar MyEtherWallet a la red AMOY (Polygon Testnet)",
    value: `
Para utilizar la testnet AMOY de Polygon desde MyEtherWallet, sigue estos pasos detallados:

---

1. **Accede a MyEtherWallet**  
   Ingresa a la página oficial de MyEtherWallet: [https://www.myetherwallet.com/](https://www.myetherwallet.com/)  
   Asegúrate de estar en el sitio auténtico y haber iniciado sesión correctamente con tu wallet.  
   ![Paso 1](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/9-1.png)

2. **Abre el selector de red**  
   En el panel derecho de la pantalla principal de MEW, ubica la sección donde se muestra la red activa (por defecto suele ser "Ethereum").  
   Haz clic sobre el nombre de la red para desplegar el selector de redes disponibles.  
   ![Paso 2](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/9-2.PNG)

3. **Busca y selecciona la red AMOY**  
   En la ventana del selector de red, cambia a la pestaña llamada **TEST** para visualizar todas las redes de prueba soportadas por MEW.  
   Desplázate por la lista hasta encontrar la opción **AMOY - Polygon (AMOY) Testnet** y haz clic sobre ella para seleccionarla.  
   Esto prepara tu entorno para operar específicamente en la testnet de Polygon.
   ![Paso 3](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/9-3.PNG)

4. **Confirma el cambio de red**  
   Al seleccionar AMOY, MEW mostrará un mensaje emergente solicitando tu confirmación para cambiar la red.  
   Lee el mensaje y haz clic en **Confirmar** para completar el proceso de cambio de red.
   ![Paso 4](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/9-4.png)

5. **Verifica que la red esté conectada correctamente**  
   Si el proceso fue exitoso, notarás que la red activa indicada en el panel de MEW ahora es **Polygon (AMOY) Testnet**.  
   A partir de aquí, puedes consultar tu saldo, hacer transacciones y operar en la testnet de Polygon directamente desde MEW, sin riesgo para tus fondos reales.
   ![Paso 5](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/9-5.png)

---
`
  }
];

export default connectAmoyNetworkMEW;
